import { Trophy, Palette, Users, Medal, Bus, Star } from 'lucide-react';
import PageHero from '@/components/PageHero';
import { Reveal, SectionHeading } from '@/components/Reveal';
import { SCHOOL_LIFE, IMG } from '@/data/content';

const LIFE_ICONS = [Trophy, Palette, Users, Medal, Bus, Star];
const LIFE_IMAGES = [
  `${IMG.students}&w=900&q=75&auto=format&fit=crop`,
  `${IMG.classroom}&w=900&q=75&auto=format&fit=crop`,
  '/images/campus-gate.jpg',
];

const SchoolLife = () => (
  <>
    <PageHero eyebrow="School Life" title="Beyond the classroom." description="Sports, culture, clubs and competitions — because childhood at Ideal is as joyful as it is disciplined." />

    <section className="py-24 sm:py-32" data-testid="school-life-sections">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 space-y-20">
        {SCHOOL_LIFE.map((item, i) => {
          const Icon = LIFE_ICONS[i];
          const flip = i % 2 === 1;
          return (
            <div key={item.title} className="grid gap-10 lg:grid-cols-12 items-center">
              <div className={`lg:col-span-5 ${flip ? 'lg:order-2' : ''}`}>
                <Reveal>
                  <div className="relative">
                    <div className={`absolute h-full w-full rounded-lg border-2 ${flip ? '-right-4 -top-4 border-gold' : '-left-4 -top-4 border-crimson'}`} aria-hidden="true" />
                    <img src={LIFE_IMAGES[i % LIFE_IMAGES.length]} alt={item.title} loading="lazy" className="relative rounded-lg w-full object-cover aspect-[4/3]" />
                  </div>
                </Reveal>
              </div>
              <div className={`lg:col-span-7 ${flip ? 'lg:order-1 lg:pr-8' : 'lg:pl-8'}`}>
                <SectionHeading number={`0${i + 1}`} eyebrow="School Life" title={item.title} />
                <Reveal delay={0.15}>
                  <p className="mt-6 text-navy/70 leading-relaxed">{item.desc}</p>
                </Reveal>
                <Reveal delay={0.25}>
                  <div className="mt-6 flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-gold"><Icon className="h-5 w-5" /></span>
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-navy/50">Ideal Public School</span>
                  </div>
                </Reveal>
              </div>
            </div>
          );
        })}
      </div>
    </section>

    <section className="bg-navy py-24 sm:py-28 noise-overlay" data-testid="student-achievements">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading dark eyebrow="Wall of Fame" title="Recent student achievements" />
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {[
            { title: 'District Topper — Class X', desc: 'Anjali Maurya scored 94% in the UP Board exams, topping the Khetasarai block.' },
            { title: 'Gold Medal — District Kabaddi', desc: 'Our U-17 kabaddi team brought home the district championship trophy.' },
            { title: 'First Prize — Science Exhibition', desc: 'A working model on rainwater harvesting won first prize at the regional exhibition.' },
          ].map((a, i) => (
            <Reveal key={a.title} delay={i * 0.08}>
              <div data-testid={`life-achievement-${i}`} className="h-full rounded-lg border border-cream/10 bg-navy-light p-7 transition-all hover:-translate-y-1 hover:border-gold/50">
                <Medal className="h-7 w-7 text-gold" />
                <h3 className="mt-4 font-display text-xl font-bold text-cream">{a.title}</h3>
                <p className="mt-2 text-sm text-cream/60 leading-relaxed">{a.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default SchoolLife;
